import React from 'react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, subtitle, action, className = '' }) => (
  <div className={`flex flex-col items-center justify-center py-16 gap-4 text-center ${className}`}>
    {icon && (
      <div className="w-14 h-14 rounded-lg bg-slate-100 flex items-center justify-center text-slate-400">
        {icon}
      </div>
    )}
    <div>
      <p className="text-sm font-bold text-slate-700 mb-1">{title}</p>
      {subtitle && <p className="text-sm text-slate-500 max-w-xs">{subtitle}</p>}
    </div>
    {action && <div className="mt-2">{action}</div>}
  </div>
);

export default EmptyState;
